import React from 'react';

export const search = (input: string, item: string, wrapper: (value: string) => void) => item
  .split(new RegExp('(' + input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi'))
  .map(i => i.toLowerCase() === input.toLowerCase() ? wrapper(i) : i);

export const searchBold = (input: string, item: string): (void | string)[] => search(input, item, (i) => <b>{i}</b>);
